import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const DarkCon = styled('div')(({ theme }) => ({
  background: colors.darkBackground,
    minHeight: '100vh' 
}))

export const WriteupCon = styled('div')(({ theme }) => ({
  '& p': {
    color: `${colors.lightestGrey} !important`,
    '& span': {
      color: `${colors.lightestGrey} !important`,
      fontSize: fontSizes.medium,
    },
  },
}))

export const StandingsCalloutCon = styled('div')(({ theme }) => ({
  '& p': {
    '& span': {
      color: `${colors.lightestGrey} !important`,
      fontSize: fontSizes.medium,
    },
  },
}))

export const ReadMore = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: colors.lightBlue,
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1, 0),
}))